import { HelpCircle } from 'lucide-react';

const DenoiseCheckbox = ({ checked, onChange }) => {
  return (
    <div className="flex items-center mt-2 mb-1">
      <label className="flex items-center cursor-pointer group">
        <div className="relative">
          <input
            type="checkbox"
            checked={checked}
            onChange={onChange}
            className="sr-only peer"
          />
          <div className="w-4 h-4 border border-[#3A3D3E] rounded bg-[#181A1B] peer-checked:bg-[#178A94] transition-all duration-200"></div>
          <div className="absolute inset-0 flex items-center justify-center text-white opacity-0 peer-checked:opacity-100 transition-opacity pointer-events-none">
            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="20 6 9 17 4 12"></polyline>
            </svg>
          </div>
        </div>
        <label className="ml-1.5 text-[#EAECEF] text-xs font-semibold">
          Denoise Audio before conversion <span className="text-[#7C8085] text-xs font-normal">(25% higher credit consumption)&nbsp;</span>
        </label>
        <div className="relative group ml-0.5">
          <HelpCircle 
            size={14} 
            className="text-[#B0B4BB] hover:text-[#EAECEF] transition-colors cursor-help" 
          />
          <div className="absolute left-0 bottom-full mb-1 w-[clamp(12rem,25vw,16rem)] 
                          p-2 bg-[#2C2F30] text-[#EAECEF] text-[clamp(0.75rem,1.5vw,0.875rem)] 
                          rounded-lg shadow-xl border border-[#3A3D3E]
                          opacity-0 group-hover:opacity-100 transition-opacity
                          pointer-events-none z-10">
            Enable Denoise to clean up background noise from your audio before voice conversion.
            This feature removes unwanted ambient sounds, hums, and static for clearer results.
            Note that denoising requires additional processing and will increase credit consumption by 25%.
            <div className="absolute left-4 bottom-[-4px] w-2 h-2 bg-[#2C2F30] 
                            border-r border-b border-[#3A3D3E] transform rotate-45">
            </div>
          </div>
        </div>
      </label>
    </div>
  );
};

export default DenoiseCheckbox;